import Box from "@material-ui/core/esm/Box";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useRouteMatch } from 'react-router-dom';
import { useMSAL } from 'auth/msalProvider';
import Divider from 'components/Divider/Divider';
import { Title } from 'components/Text';
import Lang from 'constants/language';
import { CONTACT_US } from 'constants/urls';
import { ACCESS_MANAGEMENT_PATH } from 'routes/AccessManagement/paths';
import { CUSTOMERS, CREATE_CUSTOMER } from 'routes/customers/paths';
import { HOME } from 'routes/home/paths';
import { INVOICES } from 'routes/invoices/paths';
import { AGREEMENTS } from 'routes/overview/paths';
import { REGISTER_VEHICLE_SUMMARY } from 'routes/overview/RegisterVehicle/paths';
import { TRANSFER_TAG_SUMMARY } from 'routes/overview/TransferTag/paths';
import { PASSINGS_PATH } from 'routes/passings/paths';
import PROFILE from 'routes/profile/paths';
import useStyles from './FooterStyles';
function Footer() {
  const onCustomersPage = useRouteMatch(CUSTOMERS)?.isExact;
  const onVehicleSummary = useRouteMatch(REGISTER_VEHICLE_SUMMARY)?.isExact;
  const onTransferTagSummary = useRouteMatch(TRANSFER_TAG_SUMMARY)?.isExact;
  const onCreateCustomerPage = useRouteMatch(CREATE_CUSTOMER)?.isExact;
  const {
    footerRoot,
    footerSummaryRoot,
    content,
    links,
    column,
    title,
    link,
    language
  } = useStyles();
  const {
    t,
    i18n
  } = useTranslation();
  const {
    logout
  } = useMSAL();
  const changeLanguage = lng => () => {
    i18n.changeLanguage(lng);
  };
  const languageLinks = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Title, {
    className: title
  }, t('profile_menu.language')), /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement("button", {
    className: `${link} ${language}`,
    type: "button",
    onClick: changeLanguage(Lang.norwegian)
  }, t('profile_menu.languages.norwegian')), /*#__PURE__*/React.createElement("button", {
    className: link,
    type: "button",
    onClick: changeLanguage(Lang.english)
  }, t('profile_menu.languages.english'))));
  const mainContent = /*#__PURE__*/React.createElement("div", {
    className: content
  }, /*#__PURE__*/React.createElement("div", {
    className: links
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Title, {
    className: title
  }, t('title')), /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement(Link, {
    to: HOME
  }, t('footer.home')), /*#__PURE__*/React.createElement(Link, {
    to: AGREEMENTS
  }, t('footer.vehicles')), /*#__PURE__*/React.createElement(Link, {
    to: INVOICES
  }, t('footer.invoices')), /*#__PURE__*/React.createElement(Link, {
    to: PASSINGS_PATH
  }, t('footer.passings')), /*#__PURE__*/React.createElement(Link, {
    to: ACCESS_MANAGEMENT_PATH
  }, t('footer.access_management')))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Title, {
    className: title
  }, t('profile_menu.profile')), /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement(Link, {
    to: PROFILE
  }, t('footer.customer_profile')), /*#__PURE__*/React.createElement(Link, {
    to: CUSTOMERS
  }, t('footer.change_customer')), /*#__PURE__*/React.createElement(Link, {
    to: {
      pathname: CONTACT_US
    },
    target: "_blank",
    rel: "noopener noreferrer"
  }, t('profile_menu.contact_us')), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: link,
    onClick: logout
  }, t('footer.log_out'))))), languageLinks);
  return /*#__PURE__*/React.createElement("footer", {
    className: onVehicleSummary || onTransferTagSummary ? footerSummaryRoot : footerRoot
  }, /*#__PURE__*/React.createElement(Divider, null), onCustomersPage || onCreateCustomerPage ? languageLinks : mainContent);
}
export default Footer;